<template>
  <button
    @click="toggleVoteForComment()"
    class="comment__action__button"
    :class="{ 'has-voted': hasVoted }"
    :disabled="loggedIn && user?.id == comment.user?.id || !loggedIn"
  >
    <Icon size="1.5em" name="material-symbols:arrow-upward" />
    <span>{{ numberOfVotes }}</span>
  </button>
</template>
<script setup lang="ts">
const { $api } = useNuxtApp();

const props = defineProps<{ comment: Comment; voted?: Boolean }>();
const { loggedIn, user } = useUserSession();
const hasVoted = ref(props.voted);

watch(
  () => props.voted,
  (value) => {
    hasVoted.value = value;
  }
);

const numberOfVotes = ref(
  props.comment.numberOfVotes ? props.comment.numberOfVotes : 0
);

function toggleVoteForComment() {
  let endpoint = 'vote';

  if (props.voted) {
    endpoint = 'unvote';
  }

  $api<Comment>('comments/' + props.comment.id.toString() + '/' + endpoint, {
    method: 'POST',
  }).then(function (response) {
    hasVoted.value = !hasVoted.value;
    if (hasVoted.value) {
      numberOfVotes.value++;
    } else {
      numberOfVotes.value--;
    }
  });
}
</script>

<style lang="scss" scoped>
.comment__action__button {
  font-weight: bold;
}

.has-voted {
  background-color: rgb(var(--primary) / 0.3);
}
</style>